import { serverAxios } from '@/shared/api';

export const withdrawalRequestApi = async () => {
  return await serverAxios.post(`/member/withdrawal/`);
};
